/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GiftCardResultModel from './GiftCardResultModel';

/**
* The ListGiftCardResultModel model module.
* @module model/ListGiftCardResultModel
* @version 1.0.0
*/
export default class ListGiftCardResultModel {
    /**
    * Constructs a new <code>ListGiftCardResultModel</code>.
    * @alias module:model/ListGiftCardResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>ListGiftCardResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ListGiftCardResultModel} obj Optional instance to populate.
    * @return {module:model/ListGiftCardResultModel} The populated <code>ListGiftCardResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ListGiftCardResultModel();
                        
            
            if (data.hasOwnProperty('Cards')) {
                obj['Cards'] = ApiClient.convertToType(data['Cards'], [GiftCardResultModel]);
            }
        }
        return obj;
    }

    /**
    * @member {Array.<module:model/GiftCardResultModel>} Cards
    */
    'Cards' = undefined;




}
